/*
 *   Copyright (c) 2023 RCUBE PLANET PVT LTD
 *   All rights reserved.
 */
import React, { useEffect, useState } from 'react'
import VerticalLayout from '../../layouts/VerticalLayout'
import FullLayout from '../../layouts/FullpageLayout'
import HorizontalLayout from '../../layouts/HorizontalLayout'
import themeConfig from '../../configs/themeConfig'
const layouts = {
  vertical: VerticalLayout,
  full: FullLayout,
  horizontal: HorizontalLayout,
}

const ContextLayout = React.createContext(null as any)

const Layout: React.FC = (props) => {
  const [state, setState] = useState<{
    activeLayout: string
    width: number
    lastLayout: 'horizontal' | 'vertical' | null
    direction: string
  }>({
    activeLayout: themeConfig.layout,
    width: window.innerWidth,
    lastLayout: null,
    direction: themeConfig.direction,
  })

  const fn = {
    updateWidth: () => {
      setState({ ...state, width: window.innerWidth })
    },
    handleWindowResize: () => {
      fn.updateWidth()
      if (state.activeLayout === 'horizontal' && state.width <= 1199) {
        setState({ ...state, activeLayout: 'vertical', lastLayout: 'horizontal' })
      }

      if (state.lastLayout === 'horizontal' && state.width >= 1199) {
        setState({
          ...state,
          activeLayout: 'horizontal',
          lastLayout: 'vertical',
        })
      }
    },

    handleDirUpdate: () => {
      let dir = state.direction
      if (dir === 'rtl') document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl')
      else document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr')
    },
  }

  useEffect(() => {
    if (window !== undefined) {
      window.addEventListener('resize', fn.handleWindowResize)
    }
    fn.handleDirUpdate()
    if (state.activeLayout === 'horizontal' && state.width <= 1199) {
      setState({
        ...state,
        activeLayout: 'vertical',
      })
    } else if (themeConfig.layout === 'horizontal' && state.width >= 1200) {
      setState({
        ...state,
        activeLayout: 'horizontal',
      })
    } else {
      setState({
        ...state,
        activeLayout: 'vertical',
      })
    }

    fn.handleDirUpdate()
  }, [])

  return (
    <ContextLayout.Provider
      value={{
        state: state,
        fullLayout: layouts['full'],
        VerticalLayout: layouts['vertical'],
        horizontalLayout: layouts['horizontal'],
        switchLayout: (layout: string) => {
          setState({ ...state, activeLayout: layout })
        },
        switchDir: (dir: string) => {
          setState({ ...state, direction: dir })
        },
      }}
    >
      {props.children}
    </ContextLayout.Provider>
  )
}

export { Layout, ContextLayout }
